import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const BookingApi = createApi({
  reducerPath: "BookingApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["BOOKINGAPI"],
  endpoints: (build) => ({
    getBookings: build.query({
      query: ({ page, fromDate, toDate }) => ({
        url: `/booking?page=${page}&fromDate=${fromDate}&toDate=${toDate}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BOOKINGAPI"],
    }),

    getBookingById: build.query({
      query: ({ id }) => ({
        url: `/booking/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BOOKINGAPI"],
    }),

    updateBookingStatus: build.mutation({
      query: ({ id, data }) => ({
        url: `/booking/${id}`,
        method: "PUT",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BOOKINGAPI"],
    }),

    createBooking: build.mutation({
      query: ({ data }) => ({
        url: `/booking`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BOOKINGAPI"],
    }),
    updateBookingPayment: build.mutation({
      query: ({ data }) => ({
        url: `/booking/update-payment`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BOOKINGAPI"],
    }),

    cancelBooking: build.mutation({
      query: ({ id }) => ({
        url: `/booking/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BOOKINGAPI"],
    }),

    getBookingStatistics: build.query({
      query: ({ period }) => ({
        url: `/booking/statistics?period=${period}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BOOKINGAPI"],
    }),
    getSlots: build.query({
      query: ({ date, type, orgId }) => ({
        url: `/appointments/slots?date=${date}&type=${type}&orgId=${orgId}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BOOKINGAPI"],
    }),
    calculateAmount: build.mutation({
      query: ({ data }) => ({
        url: `/calculate-amount`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BOOKINGAPI"],
    }),
  }),
});

export const {
  useGetBookingsQuery,
  useGetBookingByIdQuery,
  useUpdateBookingStatusMutation,
  useCreateBookingMutation,
  useCancelBookingMutation,
  useGetBookingStatisticsQuery,
  useUpdateBookingPaymentMutation,
  useGetSlotsQuery,
  useCalculateAmountMutation,
} = BookingApi;
